import { getProject } from "@theatre/core";
import { useRef } from "react";

import { useMemo, useState, useEffect } from "react";

import projectState from "../data/theatreState.json";

export const useSheet = (projectName, sheetName, sheetInstanceName) => {
  return useMemo(() => {
    const project = getProject(projectName, { state: projectState });
    const sheet = project.sheet(sheetName, sheetInstanceName);
    return sheet;
  }, [projectName, sheetName, sheetInstanceName]);
};

/**
 * [DEPRECATED] Don't use this. Performance issues with setting useState at 60fps
 * @param {*} sheet
 * @param {*} objectPath
 * @param {*} config
 * @returns
 */
export const useObject = (sheet, objectPath, config) => {
  const object = useMemo(() => sheet.object(objectPath, config), [sheet, objectPath, config]);
  const initialValues = useMemo(() => object.currentValues, [object]);
  const [values, setValues] = useState(initialValues);
  useEffect(() => {
    return object.onValuesChange(setValues);
  }, [object]);
  return values;
};

export const useObjectCallback = (sheet, objectPath, config, callback) => {
  // const unsubscribe = useRef();

  const object = useMemo(() => sheet.object(objectPath, config), [sheet, objectPath, config]);

  useEffect(() => {
    const unsubscribe = object.onValuesChange(callback);
    return () => {
      //HACK quickfix for stuck animations
      setTimeout(() => {
        unsubscribe();
      }, 200);
    };
  }, [object]);

  return null;
};
